enum SCHOOL_TYPES {
  CALCULATED_ON_AGE = 'CALCULATED_ON_AGE',
  PRESCHOOL = 'PRESCHOOL',
  SCHOOL = 'SCHOOL',
}

export default SCHOOL_TYPES;



// WEBPACK FOOTER //
// ./src/constants/schoolTypes.ts